import { Component, HostListener, Input, NgIterable, OnDestroy, OnInit } from '@angular/core';
import { asyncScheduler } from 'rxjs';
import { AbstractListView } from '../../directives/abstract-list-view';

export const SortCompareFn = (v1: any, v2: any) => {
  if(v1==null) { 
    return v2==null ? 0 : -1;
  } else if (v2==null) {
    return 1;
  } else {
    const strV1 = `${v1}`, strV2 = `${v2}`
    return strV1 < strV2 ? -1 : strV1 > strV2 ? 1 : 0;
  }
}

export const NumericCompareFn = (v1: any, v2: any) => {
  const num1 = Number(v1), num2 = Number(v2)
  if(isNaN(num1)) { 
    return isNaN(num2) ? 0 : -1;
  } else if (isNaN(num2)) {
    return 1;
  } else {
    return num1 < num2 ? -1 : num1 > num2 ? 1 : 0; 
  }
}

export const NumericArrayCompareFn = (v1: any, v2: any) => {
  if ( !v1 || !v1.length ) {
    v1 = [ v1 ]
  }
  if ( !v2 || !v2.length ) {
    v2 = [ v2 ]
  }
  const maxLen = Math.max(v1.length,v2.length)
  let cmpRtn : 0 | 1 | -1 = 0
  for( let i = 0; i < maxLen; i++ ) {
    var v1i = v1[i]
    var v2i = v2[i]
    if ( isNaN(v1i)  ) {
      v1i = 0
    }
    if ( isNaN(v2i) ) {
      v2i = 0
    }
    cmpRtn = NumericCompareFn( v1i, v2i )
    if ( cmpRtn ) {
      break
    }
  }
  return cmpRtn
}

export const StringArrayCompareFn = (v1: any, v2: any) => {
  if ( !v1 || !v1.length ) {
    v1 = [ v1 ]
  }
  if ( !v2 || !v2.length ) {
    v2 = [ v2 ]
  }
  const maxLen = Math.max(v1.length,v2.length)
  let cmpRtn : 0 | 1 | -1 = 0
  for( let i = 0; i < maxLen; i++ ) {
    var v1i = v1[i]
    var v2i = v2[i]
    if ( v1i==null  ) {
      v1i = ''
    }
    if ( v2i==null ) {
      v2i = ''
    }
    cmpRtn = SortCompareFn( v1i, v2i )
    if ( cmpRtn ) {
      break
    }
  }
  return cmpRtn
}

export type SortDirection = 'asc' | 'desc' | '';

export interface SortEvent {
  name: string;
  direction: SortDirection
}

@Component({
  selector: '[fesSortField]',
  templateUrl: './sort-field.component.html',
  styleUrls: ['./sort-field.component.css']
})
export class SortFieldComponent<T,U extends NgIterable<T>> implements OnInit, OnDestroy {

  @Input('fesSortField') name = '';
  @Input() valueResolver : ( rec: T, recKey: string|string[] ) => any

  @Input() sortFn = SortCompareFn; // allow custom sorts
  @Input() sortType : null | 'string' | 'stringArray' | 'numeric' | 'numericArray';
  @Input('sort') direction: SortDirection = '';
  @Input('default') set default( v: boolean | '' ){
    this.isDefault = v === '' || v
  }
  isDefault = false

  constructor( private listView : AbstractListView<T,U> ) {
    this.listView.addSortField(this)
  }

  ngOnInit(){
    switch ( this.sortType ) {
      case 'numeric':
        this.sortFn = NumericCompareFn
        break;
      case 'numericArray':
        this.sortFn = NumericArrayCompareFn
        break;
      case 'stringArray':
        this.sortFn = StringArrayCompareFn
        break;
      default:
        this.sortFn = SortCompareFn
    }
    if ( this.isDefault ) {
      asyncScheduler.schedule( () => {
        let sortEvent : SortEvent = {name: this.name, direction: this.direction }
        this.listView.onSort(sortEvent)
      })
    }
  }

  @HostListener('click') rotate() {
    this.direction = this.direction == 'desc' ? 'asc' : 'desc'
    let sortEvent : SortEvent = {name: this.name, direction: this.direction }
    this.listView.onSort(sortEvent)
  }

  sortClass() : string {
    if ( this.direction ) {
      let sortDirection = this.direction=='asc'?'up':'down' //font-awesome version uses up/down instead of asc/desc
      return 'fa fa-sort-' + sortDirection
    }
    return ""
  }

  ngOnDestroy() {
    this.listView.removeSortField(this)
  }
}
